document.addEventListener('DOMContentLoaded', () => {
  const normalize = (value) =>
    String(value || '').trim().toLowerCase();

  function getSelectedColor() {
    const checked = document.querySelector(
      'variant-selects input[name*="Color"]:checked'
    );

    if (checked) return normalize(checked.value);

    const select = document.querySelector(
      'variant-selects select[name*="Color"]'
    );

    if (select) return normalize(select.value);

    return null;
  }

  function filterImages() {
    const selectedColor = getSelectedColor();

    if (!selectedColor) return;

    document.querySelectorAll('[data-media-id]').forEach((media) => {
      const img = media.querySelector('img');

      if (!img) return;

      const alt = normalize(img.alt);

      if (alt.includes('color:white')) {
        media.style.display =
          selectedColor === 'white' ? '' : 'none';
      }

      if (alt.includes('color:black')) {
        media.style.display =
          selectedColor === 'black' ? '' : 'none';
      }
    });
  }

  filterImages();

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      setTimeout(filterImages, 100);
    }
  });
});